import type { QueryClient } from '@tanstack/react-query';
import { applyStatusHistoryTimelineItemUpdate } from 'src/modules/shared/communications/utils/cache/timeline-items/update.util';
import type { CommunicationsRealtimeStatusHistoryPayload } from '../../types/realtime.types';

/**
 * Applies a validated realtime status-history payload to owned caches.
 *
 * @param queryClient - React Query client that owns the Communications caches.
 * @param payload - Validated status-history realtime payload.
 */
export const applyStatusHistoryRealtimePayload = (
  queryClient: QueryClient,
  payload: CommunicationsRealtimeStatusHistoryPayload
): void => {
  applyStatusHistoryTimelineItemUpdate({
    queryClient,
    statusHistory: payload.resource,
    funnelId: payload.funnelId,
  });
};
